module.exports = __webpack_public_path__ + "img/reflect-01.f973bcdf.svg";